// Wayne Grudem's Systematic Theology — 7 parts, 57 chapters
export const GRUDEM_PARTS = [
  {
    part: 1,
    title: "The Doctrine of the Word of God",
    chapters: [
      { n: 1, title: "Introduction to Systematic Theology" },
      { n: 2, title: "The Word of God" },
      { n: 3, title: "The Canon of Scripture" },
      { n: 4, title: "The Four Characteristics of Scripture: (1) Authority" },
      { n: 5, title: "The Inerrancy of Scripture" },
      { n: 6, title: "The Four Characteristics of Scripture: (2) Clarity" },
      { n: 7, title: "The Four Characteristics of Scripture: (3) Necessity" },
      { n: 8, title: "The Four Characteristics of Scripture: (4) Sufficiency" },
    ],
  },
  {
    part: 2,
    title: "The Doctrine of God",
    chapters: [
      { n: 9, title: "The Existence of God" },
      { n: 10, title: "The Knowability of God" },
      { n: 11, title: 'The Character of God: "Incommunicable" Attributes' },
      { n: 12, title: 'The Character of God: "Communicable" Attributes (Part 1)' },
      { n: 13, title: 'The Character of God: "Communicable" Attributes (Part 2)' },
      { n: 14, title: "God in Three Persons: The Trinity" },
      { n: 15, title: "Creation" },
      { n: 16, title: "God's Providence" },
      { n: 17, title: "Miracles" },
      { n: 18, title: "Prayer" },
      { n: 19, title: "Angels" },
      { n: 20, title: "Satan and Demons" },
    ],
  },
  {
    part: 3,
    title: "The Doctrine of Man",
    chapters: [
      { n: 21, title: "The Creation of Man" },
      { n: 22, title: "Man as Male and Female" },
      { n: 23, title: "The Essential Nature of Man" },
      { n: 24, title: "Sin" },
      { n: 25, title: "The Covenants Between God and Man" },
    ],
  },
  {
    part: 4,
    title: "The Doctrines of Christ and the Holy Spirit",
    chapters: [
      { n: 26, title: "The Person of Christ" },
      { n: 27, title: "The Atonement" },
      { n: 28, title: "Resurrection and Ascension" },
      { n: 29, title: "The Offices of Christ" },
      { n: 30, title: "The Work of the Holy Spirit" },
    ],
  },
  {
    part: 5,
    title: "The Doctrine of the Application of Redemption",
    chapters: [
      { n: 31, title: "Common Grace" },
      { n: 32, title: "Election and Reprobation" },
      { n: 33, title: "The Gospel Call and Effective Calling" },
      { n: 34, title: "Regeneration" },
      { n: 35, title: "Conversion (Faith and Repentance)" },
      { n: 36, title: "Justification (Right Legal Standing Before God)" },
      { n: 37, title: "Adoption (Membership in God's Family)" },
      { n: 38, title: "Sanctification (Growth in Likeness to Christ)" },
      { n: 39, title: "Baptism in and Filling with the Holy Spirit" },
      { n: 40, title: "The Perseverance of the Saints (Remaining a Christian)" },
      { n: 41, title: "Death and the Intermediate State" },
      { n: 42, title: "Glorification (Receiving a Resurrection Body)" },
      { n: 43, title: "Union with Christ" },
    ],
  },
  {
    part: 6,
    title: "The Doctrine of the Church",
    chapters: [
      { n: 44, title: "The Church: Its Nature, Its Marks, and Its Purposes" },
      { n: 45, title: "The Purity and Unity of the Church" },
      { n: 46, title: "The Power of the Church" },
      { n: 47, title: "Church Government" },
      { n: 48, title: "Means of Grace Within the Church" },
      { n: 49, title: "Baptism" },
      { n: 50, title: "The Lord's Supper" },
      { n: 51, title: "Worship" },
      { n: 52, title: "Gifts of the Holy Spirit (1): General Questions" },
      { n: 53, title: "Gifts of the Holy Spirit (2): Specific Gifts" },
    ],
  },
  {
    part: 7,
    title: "The Doctrine of the Future",
    chapters: [
      { n: 54, title: "The Return of Christ: When and How?" },
      { n: 55, title: "The Millennium" },
      { n: 56, title: "The Final Judgment and Eternal Punishment" },
      { n: 57, title: "The New Heavens and New Earth" },
    ],
  },
];

export const TOTAL_CHAPTERS = 57;

export const getChapterInfo = (chapterNumber) => {
  for (const part of GRUDEM_PARTS) {
    const ch = part.chapters.find((c) => c.n === chapterNumber);
    if (ch) return { ...ch, part: part.part, partTitle: part.title };
  }
  return null;
};
